import DataTile from "./DataTile";
import {fetchTargets} from "../../../actions";
import React from "react";
import { bbTranslateRiskToColor} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";
import RiskRibbon from "../../risk/RiskRibbon";
import BBIconComputerBugCVE from "../../../assets/bbCustomIcons/BBIconComputerBugCVE";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    // const customer = customers ? customers[customerIdToUse] ? customers[customerIdToUse] : null : null;
    //from the customer, pull the target data if it exists
    // const targets = customer ? customer.targets ? customer.targets : null : null;

    // const valueFunction = (stateData) => {
    //     // console.log("valueFunction here is stateData", stateData);
    //     if (stateData && stateData[customerIdToUse] && stateData[customerIdToUse].targets) {
    //         let vulnsArray = [];
    //         const vulnerableTargets = stateData[customerIdToUse].targets ? filterObject(targets, (_, target) => target.Vulnerabilities) : null;
    //         // console.log("got these vulnerable targets",vulnerableTargets )
    //         for (let targetId in vulnerableTargets) {
    //             // console.log("evaluating ", vulnerableTargets[targetId]);
    //             const foundVulns = bbGetArrayOfVulnsFromObjectOrString(vulnerableTargets[targetId].Vulnerabilities);
    //             // console.log("foundVulns is ", foundVulns, "from ", vulnerableTargets[targetId].Vulnerabilities);
    //             vulnsArray = vulnsArray.concat(foundVulns);
    //         }
    //         return vulnsArray.length;
    //     } else {
    //         return null;
    //     }
    // }

    const valueFunction = (stateData) => stateData ? stateData[customerIdToUse] ? stateData[customerIdToUse].vulnerabilities : null : null;

    const translateValueToRisk = (value) => {
        if (typeof value !== "number") {
            return null
        } else if (value <= 0) {
            return 0
        } else if (value <= 2) {
            return 1
        } else if (value <= 5) {
            return 2
        } else if (value <= 8) {
            return 3
        } else {
            return 4
        }
    }

    const colorFunction = (stateData) => {
        const num = valueFunction(stateData);
        return bbTranslateRiskToColor(translateValueToRisk(num));
    }

    const riskRibbon = (stateData) => {
        const num = translateValueToRisk(valueFunction(stateData));
        return num
            ? <RiskRibbon ratingBy5={num} />
            : null;
    }

    return (
        <>
        {/*{targets && (*/}
            <DataTile
                colorBgFunction={colorFunction}
                subTitle="CVEs"
                tipText={"The number of NIST Common Vulnerabilities and Exposures (CVEs) detected across all detectable hosts.  CVEs provide attack vector opportunities for attackers."}
                icon={<BBIconComputerBugCVE style={{fontSize: "70px"}}/>}
                stateName="customer"
                stateElement="metaTargets"
                // useDeepDataStore
                // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse].targets : null : null}
                stateLoaderName="loadingTargets"
                stateLoaderError="loadingTargetsError"
                stateFetchAction={fetchTargets({
                    customerId: customerIdToUse
                })}
                preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
                valueFunction={valueFunction}
                ribbonFunction={riskRibbon}
                // showKRIRibbon
                requiresModule={"monitor"}
            />
        {/*)}*/}
        </>
    );
}

export default Tile;